export const addressFieldsKeys = {
  all: ["addressFields"] as const,
  byCountry: (countryCode: string, languageIso?: string) =>
    ["addressFields", countryCode, languageIso] as const,
};
